import React from 'react';
import { X, Trash2, Calendar, Clock, User } from 'lucide-react';
interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDeleteClick: () => void;
  analysisData: any;
}
const SettingsModal: React.FC<SettingsModalProps> = ({
  isOpen,
  onClose,
  onDeleteClick,
  analysisData
}) => {
  if (!isOpen) return null;
  // Format date
  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-1165" data-mp="21vlk09u78ips">
      <div className="relative w-full max-w-md mx-auto bg-white rounded-lg shadow-lg p-6" data-id="element-1166" data-mp="26x2n8c05oh9j">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-1167" data-mp="1sxtf7zm3stgn">
          <X size={20} data-id="element-1168" data-mp="3hurkjco3yveu" />
        </button>
        <h3 className="text-xl font-semibold mb-6 text-gray-900" data-id="element-1169" data-mp="3htq6czbspssw">
          Configurações do Relatório
        </h3>
        <div className="space-y-4" data-id="element-1170" data-mp="3cv564zwjn94g">
          <h4 className="text-lg font-medium text-gray-900" data-id="element-1171" data-mp="3rsxkvpu9nthl">
            Informações do Relatório
          </h4>
          <div className="space-y-3" data-id="element-1172" data-mp="3mu4ai6aa0iln">
            <div className="flex items-start" data-id="element-1173" data-mp="3mv5skuppm5cv">
              <Calendar size={18} className="text-gray-700 mt-0.5 mr-2" data-id="element-1174" data-mp="2z49xnopyiu1e" />
              <div data-id="element-1175" data-mp="2z25uxa3so12p">
                <p className="text-sm text-gray-700 font-medium" data-id="element-1176" data-mp="2u5734y7ls67o">
                  Data de criação
                </p>
                <p className="font-medium text-gray-900" data-id="element-1177" data-mp="38ulda8j06ro4">
                  {formatDate(analysisData.createdAt)}
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1178" data-mp="341idvjrjoo00">
              <Clock size={18} className="text-gray-700 mt-0.5 mr-2" data-id="element-1179" data-mp="2gcqvfk3rbk0f" />
              <div data-id="element-1180" data-mp="2bexmwkezedwz">
                <p className="text-sm text-gray-700 font-medium" data-id="element-1181" data-mp="2bfh5828jn4bj">
                  Última atualização
                </p>
                <p className="font-medium text-gray-900" data-id="element-1182" data-mp="312bjp7omfr1w">
                  {formatDate(analysisData.updatedAt)}
                </p>
              </div>
            </div>
            {analysisData.metadata?.usuario && <div className="flex items-start" data-id="element-1183" data-mp="39x828qu8eg2f">
                <User size={18} className="text-gray-700 mt-0.5 mr-2" data-id="element-1184" data-mp="3euhpq0y28hnm" />
                <div data-id="element-1185" data-mp="2i3z0et3zx0sl">
                  <p className="text-sm text-gray-700 font-medium" data-id="element-1186" data-mp="2i4qu1ye18og8">
                    Criado por
                  </p>
                  <p className="font-medium text-gray-900" data-id="element-1187" data-mp="2m6c296fmgek3">
                    {analysisData.metadata.usuario.nome || analysisData.metadata.usuario.email}
                  </p>
                </div>
              </div>}
          </div>
          <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-1188" data-mp="6exy16d1f7ao">
            <h4 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1189" data-mp="6gitcy76eu9l">Ações</h4>
            <button onClick={onDeleteClick} className="w-full px-4 py-2 bg-red-50 text-red-600 rounded-md hover:bg-red-100 flex items-center justify-center" data-id="element-1190" data-mp="bby6fnxd0m4y">
              <Trash2 size={16} className="mr-2" data-id="element-1191" data-mp="1qwz1c477c6ke" />
              Excluir relatório
            </button>
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-1192" data-mp="1m3e3qd9itelq">
          <button onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200" data-id="element-1193" data-mp="1h5m6r4u0r2ao">
            Fechar
          </button>
        </div>
      </div>
    </div>;
};
export default SettingsModal;